import { Facebook, Instagram, Linkedin, Mail, MapPin, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-ophira-dark border-t border-ophira-darkgray pt-20 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-16 w-16 flex items-center justify-center">
                <img src="/logo.png" alt="YouAux Logo" className="w-full h-full object-contain" />
              </div>
              <span className="font-bold text-2xl text-white">YouAux</span>
            </div>
            <p className="text-white/85 mb-6">
              YouAux is a comprehensive music distribution platform that helps independent artists reach a global audience while keeping 100% ownership of their music.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://www.facebook.com/share/1CTF2Mpsie/?mibextid=qi2Omg" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-ophira-yellow rounded-full h-10 w-10 flex items-center justify-center h-10 w-10"
                aria-label="Visit YouAux on Facebook"
              >
                <Facebook className="h-4 w-4 text-black" />
              </a>
              <a 
                href="https://x.com/YouAuxMusic" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="ophira-social-icon"
                aria-label="Follow YouAux on X (formerly Twitter)"
              >
                <Twitter className="h-4 w-4" />
              </a>
              <a 
                href="https://www.instagram.com/youaux" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-ophira-yellow rounded-full h-10 w-10 flex items-center justify-center h-10 w-10"
                aria-label="Follow YouAux on Instagram"
              >
                <Instagram className="h-4 w-4 text-black" />
              </a>
              <a 
                href="https://www.linkedin.com/company/youaux-entertainment/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-ophira-yellow rounded-full h-10 w-10 flex items-center justify-center h-10 w-10"
                aria-label="Connect with YouAux on LinkedIn"
              >
                <Linkedin className="h-4 w-4 text-black" />
              </a>
            </div>
          </div>
          
          <div className="hidden md:block md:col-span-2"></div>
          
          <div className="md:col-span-3 text-left">
            <h3 className="ophira-footer-heading">Main Link</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors">About</Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/pricing" className="text-white/80 hover:text-white transition-colors">Pricing</Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white transition-colors">Blog</Link>
              </li>
              <li>
                <Link to="/sell-your-music" className="text-white/80 hover:text-white transition-colors">Sell Your Music</Link>
              </li>
            </ul>
          </div>
          
          <div className="md:col-span-3 text-left">
            <h3 className="ophira-footer-heading">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:support@youaux.com" className="text-white/80 hover:text-white transition-colors">Email Support</a>
              </li>
              <li>
              <Link to="/terms-and-conditions" className="text-white/80 hover:text-white transition-colors">Terms & Condition</Link>
              </li>
              <li>
                <Link to="/privacy" className="text-white/80 hover:text-white transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/anti-fraud-policy" className="text-white/80 hover:text-white transition-colors">Anti-Fraud Policy</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-16 mb-10">
          <div>
            <h4 className="ophira-footer-heading">Address</h4>
            <p className="flex items-start gap-2 text-white/75">
              <MapPin size={18} className="mt-1 flex-shrink-0 text-ophira-yellow" />
              <span>B1/639 A, Janakpuri, West Delhi, Delhi 110058, India</span>
            </p>
            <p className="flex items-start gap-2 text-white/75 mt-1">
              <MapPin size={18} className="mt-1 flex-shrink-0 text-ophira-yellow" />
              <span>701 Tillery Street Unit 12 Suite 3534, Austin, Texas, 78702, United States</span>
            </p>
          </div>

          <div>
            <h4 className="ophira-footer-heading">Contact Us</h4>
            <p className="flex items-start gap-2 text-white/75">
              <Mail size={18} className="mt-1 flex-shrink-0 text-ophira-yellow" />
              <span>support@youaux.com</span>
            </p>
          </div>
        </div>
        
        <div className="border-t border-ophira-darkgray/70 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/90 text-sm mb-4 md:mb-0">
              Copyright © 2024 YouAux | All Rights Reserved to YouAux Entertainment Pvt. Ltd.
            </p>
            <p className="text-white/90 text-sm">
              Made with <span role="img" className="text text-lg" aria-label="love"> ♥ </span> for Artists
            </p>
            {/* <div className="flex space-x-6">
              <Link to="/terms-and-conditions" className="text-white/75 hover:text-white text-sm transition-colors">
                Terms & Condition
              </Link>
              <Link to="/privacy" className="text-white/75 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

